export default __webpack_public_path__ + "static/media/home-events-conference-img-12.52868c45.jpg";